<template lang="pug">
.cat-link-wrapper(@click="collapsed = !collapsed")
  Icon.mobile-toggle(v-if="collapsed" name="arrow-right")
  Icon.mobile-toggle(v-else name="arrow-down")
  .cat-link.logo-link(:class="{active: $route.path === '/theindex', collapsed}")
    RogueLink.theindex-nav-link(to="/theindex")
      img.logo(src='@/assets/theindex-logo.svg' :alt="__('The Index')")
  .cat-link(v-for="category in categories" :class="{active: $route.path === `/theindex/${category.slug}`, collapsed}")
    RogueLink.theindex-nav-link(v-if="!active" :to="`/theindex/${category.slug}`")
      | {{ __(category.name) }}
    span.theindex-nav-link(v-else)
      | {{ __(category.name) }}  
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { INDEX_CATEGORY_MAP } from '../data'

const collapsed = ref<boolean>(true)

const categories = [17, 18, 330, 804, 805, 806, 103, 19, 105, 104]
  .map(id => ({ id, name: INDEX_CATEGORY_MAP[id]?.name.replace('News & Press', 'News'), slug: INDEX_CATEGORY_MAP[id]?.slug }))
  .filter(cat => !!cat.slug)
</script>

<style lang="scss" scoped>
.cat-link-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: $space-m;
  margin-bottom: $space-xs;
  position: relative;

  .logo {
    height: 14px;
    width: auto;
    margin: 0;
    margin-bottom: 1px;
    vertical-align: bottom;
  }

  @include mobile() {
    flex-direction: column;
    margin-bottom: $space-m;
  }

  @include tablet-and-small-desktop() {
    flex-direction: column;
  }
}

.cat-link {
  align-items: center;
  display: flex;
  vertical-align: middle;

  @include mobile() {
    padding-left: $space-l;
  }

  @include tablet-and-small-desktop() {
    padding-left: $space-l;
  }

  &.collapsed:not(.active) {
    @include mobile() {
      display: none;
    }

    @include tablet-and-small-desktop() {
      display: none;
    }
  }

  &.active:not(.logo-link) {
    a,span {
      color: $color-red-dark;
    }
  }
  
  a, span {
    cursor: pointer;
    color: $color-black;
    text-transform: uppercase;
    text-decoration: none;
    font-weight: bold;
    font-size: $size-xs;

    &:hover {
      color: $color-red-dark;
    }
  }
}

.mobile-toggle {
  display: none;

  @include mobile() {
    display: block;
    position: absolute;
  }

  @include tablet-and-small-desktop() {
    display: block;
    position: absolute;
  }
}
</style>